import { Injectable } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { BehaviorSubject, Observable, Subscription, Subject } from 'rxjs';
import { Respuesta } from '../_models/shared/_index';
import { environment } from '../../environments/environment';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { take } from 'rxjs/operators';

@Injectable()
export class MessagingService {
	currentMessage = new BehaviorSubject(null);
	items: Observable<any[]>;
	constructor(
		private angularFireDB: AngularFireDatabase,
		private angularFireAuth: AngularFireAuth,
		private angularFireMessaging: AngularFireMessaging,
		private http: HttpClient
	) {
		// this.angularFireMessaging.messaging.subscribe((_messaging) => {
		// 	_messaging.onMessage = _messaging.onMessage.bind(_messaging);
		// 	_messaging.onTokenRefresh = _messaging.onTokenRefresh.bind(_messaging);
		// });
		this.angularFireMessaging.messages.subscribe((message) => {
			console.log(message);
		});
	}
	fcmSubscription: Subscription;
	public authTokenSubject: Subject<string> = new Subject<string>();
	public token: any;
	private getFirebaseAuthUrl = environment.rest + '/User/GetFirebaseAuth';
	/**
	 * actualiza el token en la firebase
	 *
	 * @param id el id con el que identificamos el token
	 * @param token
	 */
	options = {
		headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
		withCredentials: true,
	};
	updateToken(id, token) {
		// we can change this function to request our backend service
		this.angularFireAuth.authState.pipe(take(1)).subscribe(() => {
			const data = {};
			data[id] = token;
			this.angularFireDB.object('fcmTokens/').update(data);
		});
	}
	getToken(): Observable<string | null> {
		return this.angularFireMessaging.getToken;
	}

	public getFirebaseAuth() {
		this.http
			.post<Respuesta>(this.getFirebaseAuthUrl, null, this.options)
			.subscribe((respuesta) => this.authTokenSubject.next(respuesta.Data));
	}
	login() {
		if (this.authTokenSubject) {
			this.getFirebaseAuth();
			this.authTokenSubject.subscribe((token) => {
				console.log('authtoken', token);
				var user = this.angularFireAuth
					.signInWithCustomToken(token)
					.catch(function (error) {
						// Handle Errors here.
						var errorCode = error.code;
						var errorMessage = error.message;
						// ...
					});
				console.log(user);
			});
		} else {
			console.error(
				'|k|¿QUE PASO ACA ? llama a krone si viste este mensaje :P '
			);
		}
	}

	logout() {
		this.deleteToken();
		this.angularFireAuth
			.signOut()
			.then(function () {
				// Sign-out successful.
			})
			.catch(function (error) {
				// An error happened.
			});
	}
	deleteToken() {
		this.angularFireMessaging
			.deleteToken(this.token)
			.subscribe((result) => console.log('token fcm borrado'));
	}
	/**
	 * request permission for notification from firebase cloud messaging
	 *
	 * @param userId userId
	 */
	requestPermission(userId) {
		this.angularFireAuth.user.subscribe((user) => (userId = user.uid));
		this.angularFireMessaging.requestToken.subscribe(
			(token) => {
				this.token = token;
				this.updateToken(userId, token);
			},
			(err) => {
				console.error('Unable to get permission to notify.', err);
			}
		);
	}

	/**
	 * hook method when new notification received in foreground
	 */
	receiveMessage() {
		this.fcmSubscription = this.angularFireMessaging.messages.subscribe(
			(payload) => {
				console.log('new message received. ', payload);
				this.currentMessage.next(payload);
			}
		);
	}

	getNotificaciones() {
		// this.angularFireAuth.auth.onAuthStateChanged(user => {console.log(user)});
		this.items = this.angularFireDB
			.list('notificaciones/' + 'amis_')
			.valueChanges();
	}
}
